import { Injectable } from '@angular/core';


@Injectable()
export class SensorUtilService {

  constructor () {}

  getRealSensorValue  (value, minSrc, maxSrc, min, max,gaps ,  sensor) {
    const minValue = Math.min(minSrc, maxSrc);
    const maxValue = Math.max(minSrc, maxSrc);
    if (
      value &&
      Number.isFinite(minValue) &&
      Number.isFinite(maxValue) &&
      (value < minValue || value > maxValue) &&
      sensor &&
      sensor.OUT_RANGE
    ) {
  
      return undefined;
    }
  
  
  
  
      var realValue = value;
     
      if (Number.isFinite(maxSrc) && Number.isFinite(minSrc) && Number.isFinite(max) && Number.isFinite(min) && maxSrc - minSrc != 0) {
        realValue = ((value - minSrc) * (max - min)) / (maxSrc - minSrc) + min;
      }
  
    if(gaps && gaps.length && gaps.length>0 && realValue){
    
      for (var i = 0; i < gaps.length; i++) {
        const gap =gaps[i]
        if(gap != null &&
          ((gap.minSrcGap !=null && realValue >= gap.minSrcGap) || gap.minSrcGap == null) 
        && ((gap.maxSrcGap !=null && realValue <= gap.maxSrcGap) || gap.maxSrcGap == null) 
       && Number.isFinite(gap. gapValue)
       && Number.isFinite(realValue) )
       {
      //    console.log("realvalue avant gap",realValue,gap.minSrcGap,gap.maxSrcGap, gap. gapValue);
        realValue += gap. gapValue
      //    console.log("realvalue apres gap",realValue);
        break;
       }
      }
    
      
      // console.groupEnd();
    }
  
      return realValue;
    };
  
  
  getOdoAbsoluteSRC() {
    return  ["rt.io.CAN_ODO"];
  }
  getUnitList(){
    return [
      {"name":"NO_UNIT", "code": ""},
      {"name":"LITRE", "code": "L"},
      {"name":"CELSIUS_DEGREE", "code": "°C"},
      {"name":"FARENHEIT_DEGREE", "code": "°F"},
      {"name":"KILOMETRE", "code": "Km"},
      {"name":"KILOGRAM", "code": "Kg"},
      {"name":"KILOMETRE_PER_HOUR", "code": "Km/h"},
      {"name":"MILE_PER_HOUR", "code": "Mph"},
      {"name":"DEGREE", "code": "°"},
      {"name":"METER", "code": "M"},
      {"name":"MILLI_AMPERES", "code": "mA"},
      {"name":"ROTARY_PER_MINUTE", "code": "Rpm"},
      {"name":"VOLTS", "code": "V"},
      {"name":"PERCENTAGE", "code": "%"}
    ]
  }

getSensorsTypes = function () {
    return {
      BINARY: ["TAXI_STATUS", "DOOR_STATUS", "REFRIGERATION_STATUS", "SPINNING_STATUS", "MISSION_STATUS", "CABINE_STATUS", "OIL_STATUS"],
      STATUS: {
        TAXI_STATUS: {
          enabled: "Libre",
          disabled: "Occupé"
        },
        DOOR_STATUS: {
          enabled: "Ouvert",
          disabled: "Fermé"
        },
        CABINE_STATUS: {
          enabled: "Ouvert",
          disabled: "Fermé"
        },
        REFRIGERATION_STATUS: {
          enabled: "Activé",
          disabled: "Désactivé"
        },
        SPINNING_STATUS: {
          enabled: "En rotation",
          disabled: "STOP"
        },
        MISSION_STATUS: {
          enabled: "Activé",
          disabled: "Désactivé"
        },
        OIL_STATUS: {
          enabled: "Allumée",
          disabled: "Éteinte"
        }
      },
      ANALOGIC: ["TEMPERATURE", "FUEL_LEVEL", "GAS", "FUEL_USED", "PRESSURE", "ODOMETER", "RPM", "HUMIDITY", "ENGINE_TEMP"],
      ICONS: {
        DOOR_STATUS_ON: "door-opened",
        DOOR_STATUS_OFF: "door-closed",
        CABINE_STATUS_ON: "cabine-opened",
        CABINE_STATUS_OFF: "cabine-closed",
        ODOMETER: "kilometrage",
        TEMPERATURE: "temperature",
        FUEL_LEVEL: "fuel",
        SPINNING_STATUS_OFF: "rotation-stop",
        SPINNING_STATUS_ON: "rotation",
        TAXI_STATUS_ON: "taxi-available",
        TAXI_STATUS_OFF: "taxi-unavailable",
        FUEL_USED: "fuel-used",
        GAS: "gas",
        RPM: "rpm",
        REFRIGERATION_STATUS_ON: "refrigerator-start",
        REFRIGERATION_STATUS_OFF: "refrigerator-stop",
        PRESSURE: "pressure",
        HUMIDITY: "humidity",
        MISSION_STATUS_ON: "mission-status-enabled",
        MISSION_STATUS_OFF: "mission-status-disabled",
        OIL_STATUS_ON: "oil-status-enabled",
        OIL_STATUS_OFF: "oil-status-disabled",
        ENGINE_TEMP: "temperature"

      }
    };
  };
  getSensorFamily(type) {
    let family = "ANALOGIC";
    if(this.getSensorsTypes().BINARY.indexOf(type) > -1){
      family = "BINARY";
    }
    if(this.getSensorsTypes().ANALOGIC.indexOf(type) > -1){
      family = "ANALOGIC";
    }

    return family;
  }

  isAbsoluteValue(sensor){
    console.log("IS Absolute ", sensor);
    if(sensor.type=="ODOMETER"){
      sensor.isAbsolute = this.getOdoAbsoluteSRC().indexOf(sensor.src) >= 0;
    }
    console.log("IS Absolute 2 ", sensor);
    return sensor;
  }

}


// WEBPACK FOOTER //
// ./src/services/sensors.service.ts